import SolutionPageTemplate from "./SolutionPageTemplate";

const QuickMassageEventosCorporativos = () => (
  <SolutionPageTemplate
    title="Quick Massage e Eventos Corporativos"
    intro={[
      "A Quick Massage é uma solução prática e eficiente para proporcionar momentos de relaxamento e recuperação durante a jornada de trabalho ou em eventos corporativos. Com atendimentos rápidos e objetivos, contribui para o alívio das tensões musculares e para a sensação imediata de bem-estar.",
      "Também é uma excelente opção para SIPATs, feiras, convenções, confraternizações e outras ações corporativas.",
    ]}
    benefits={[
      "Alívio rápido de tensões musculares e desconfortos físicos",
      "Redução do estresse e aumento do bem-estar",
      "Promoção de pausas saudáveis durante a rotina de trabalho",
      "Apoio à prevenção de sobrecargas físicas",
      "Valorização dos colaboradores e participantes de eventos",
      "Atendimento prático e adaptado à dinâmica da empresa",
    ]}
    sectionId="quick-massage-eventos-corporativos"
    modifier="solution-page--quick-massage"
  />
);

export default QuickMassageEventosCorporativos;
